import React from 'react';
import { ReferenceManyField, Pagination, useListContext } from 'react-admin';
import ChargeGrid from '../../charges/components/ChargeGrid';

const ChargeGridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total Charges: {total || 0}
                </div>
            )}
            <ChargeGrid {...props} />
            <Pagination />
        </>
    );
};

export const OrderChargesList = props => (
    <ReferenceManyField
        reference="charges"
        target="orderId"
        perPage={25}
        filter={{ orderId: props.record.id }}
        {...props}
    >
        <ChargeGridWithTotal {...props} />
    </ReferenceManyField>
);
